<template>
  <div class="column-view">
    <div class="margin-bottom-10" v-if="list.length>0"><el-button @click="exportExcel" icon="el-icon-download" type="primary">导出为Excel</el-button></div>
    <el-table ref="table" :data="list" v-loading="loading" >
      <el-table-column label="新提拔干部民主评议表" align="center">
        <el-table-column label="单位" width="250px" align="center">
          <template slot-scope="scope">
            {{scope.row.dept_name}}
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="250px" align="center">
          <template slot-scope="scope">
            {{scope.row.employee_name}}
          </template>
        </el-table-column>
        <el-table-column label="评议人数" width="250px" align="center">
          <template slot-scope="scope">
            {{scope.row.join_meeting_number}}
          </template>
        </el-table-column>
        <el-table-column label="对提拔该干部的看法" align="center">
          <el-table-column label="认同" width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.agree_count}}
            </template>
          </el-table-column>
          <el-table-column label="比例"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.agree_rate?(scope.row.agree_rate+'%'):''}}

            </template>
          </el-table-column>
          <el-table-column label="基本认同"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.basic_agree_count}}
            </template>
          </el-table-column>
          <el-table-column label="比例"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.basic_agree_rate?(scope.row.basic_agree_rate+'%'):''}}

            </template>
          </el-table-column>
          <el-table-column label="不认同"  width="100px" align="center">
            <template slot-scope="scope">

              {{scope.row.disagree_count}}
            </template>
          </el-table-column>
          <el-table-column label="比例"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.disagree_rate?(scope.row.disagree_rate+'%'):''}}

            </template>
          </el-table-column>
          <el-table-column label="不了解"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.not_understand_count}}
            </template>
          </el-table-column>
          <el-table-column label="比例"  width="100px" align="center">
            <template slot-scope="scope">
              {{scope.row.not_understand_rate?(scope.row.not_understand_rate+'%'):''}}
            </template>
          </el-table-column>
        </el-table-column>

      </el-table-column>
      <template #empty>
        <yc-no-content des="暂未生成数据汇总表"></yc-no-content>
      </template>
    </el-table>
  </div>

</template>

<script>
export default {
  name: "secondTable",
  data(){
    return {
      loading:false,
      list:[],
    }
  },
  methods:{
    showLoading(){
      this.loading=true;
    },
    setData(list){
      this.list=list;
      this.loading=false;
    },
    exportExcel(){
      this.$commonUtils.exportExcel(this.$refs.table,'新提拔干部民主评议表');
    }
  }
}
</script>

<style scoped>

</style>
